<div class="text-container" [class.disabled]="disabled">
  <div [class.disabled]="disabled" i18n>
    <span class="instruction-text" [class.disabled]="disabled">{{ instructionText }}</span>
  </div>
  <div class="description-text">{{ descriptionText }}</div>
</div>
